import type { PhoneCheck } from '@/api/endpoints/settings'

/** A frase de veredito do "Testar celular", acima da lista de passos. */
export function phoneCheckVerdict(result: PhoneCheck): { ok: boolean; text: string } {
  if (result.busy) {
    return { ok: false, text: 'O celular está em uso agora (drenagem de capas). Tente de novo em alguns minutos.' }
  }
  const seconds = (result.total_ms / 1000).toFixed(1)
  if (result.ok) {
    const off = result.enabled ? '' : ' A capa pelo celular está desligada neste servidor.'
    return { ok: true, text: `Celular conectado e obedecendo aos comandos (${seconds} s).${off}` }
  }
  const failed = result.steps.find((step) => !step.ok)
  return { ok: false, text: failed ? `Parou em "${failed.label}".` : 'O teste não terminou.' }
}
